export default "__VITE_ASSET__CkyC0znR__"